import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MainLayout from "../layouts/MainLayout";
import { ApplicationState } from "../store";
import { executeSession, updateResults } from "../store/slices/valimateSlice";
import Spinner from "../components/DNVSpinner";
import {
  ValimateExecutionStatus,
  ValimateExecutionSummaryVM,
} from "../autogenerated/models";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { Divider, Row, Statistic, Col, Tabs } from "antd";
import SessionRunResult from "../components/Results/SessionRunResults";
import SessionStatus from "../components/SessionStatus";

import SelectionsSummary from "../components/Summary/SelectionsSummary";
import SelectedTestCasesTable from "../components/Summary/SelectedTestCasesTable";

let SessionRunPage = (props: any) => {
  const { isLoading, rerunningTestCases, downloading } = useSelector(
    (state: ApplicationState) => state.valimate
  );
  let {
    valimateTestCaseResult: results,
    statusName,
    statusShort,
    sessionName,
    declarationOfConformity,
    choices,
  } = useSelector((state: ApplicationState) => state.valimate.results);

  results = results || [];

  const sessionId = props.match.params.sessionId;
  const dispatch = useDispatch();

  const { TabPane } = Tabs;

  const [connection, setConnection] = useState<null | HubConnection>(null);

  useEffect(() => {
    dispatch(executeSession(sessionId));
  }, [dispatch, sessionId]);

  useEffect(() => {
    const connect = new HubConnectionBuilder()
      .withUrl(`/hubs/valimateSession?sessionId=${sessionId}`)
      .withAutomaticReconnect()
      .build();

    setConnection(connect);
  }, [sessionId]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection.on(
            "UpdateExecutionStatus",
            (results: ValimateExecutionSummaryVM) => {
              dispatch(updateResults(results));
            }
          );
        })
        .catch((error) => console.log(error));

      return () => {
        connection.stop();
      };
    }
  }, [dispatch, connection]);

  let tests = 0;
  let passed = 0;
  let failed = 0;
  let inconclusive = 0;
  results?.forEach((result) => {
    result.testConfigurations?.forEach((configurationResult) => {
      tests += 1;
      if (
        configurationResult.execution?.status === ValimateExecutionStatus.Passed
      )
        passed += 1;
      else if (
        configurationResult.execution?.status === ValimateExecutionStatus.Failed
      )
        failed += 1;
      else if (
        configurationResult.execution?.status ===
        ValimateExecutionStatus.Inconclusive
      )
        inconclusive += 1;
    });
  });
  let pending = tests - passed - failed - inconclusive;

  return (
    <div className="sessionRunPage">
      <MainLayout>
        <div className="container">
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              <h1 className="headline">
                {sessionName}{" "}
                <small>
                  {statusShort && statusName && (
                    <SessionStatus
                      status={statusShort}
                      name={statusName}
                      iconOnly={false}
                    />
                  )}
                </small>
              </h1>
              <Row gutter={16}>
                <Col span={3} offset={5}>
                  <Statistic
                    title="Tests"
                    value={tests}
                    valueStyle={{ color: "#0F204B", fontWeight: "bold" }}
                  />
                </Col>
                <Col span={3}>
                  <Statistic
                    title="Successes"
                    value={passed}
                    valueStyle={{ color: "#36842D" }}
                  />
                </Col>
                <Col span={3}>
                  <Statistic
                    title="Fails"
                    value={failed}
                    valueStyle={{ color: "#C4262E" }}
                  />
                </Col>
                <Col span={3}>
                  <Statistic title="Inconclusive" value={inconclusive} />
                </Col>
                <Col span={3}>
                  <Statistic title="Pending" value={pending} />
                </Col>
              </Row>
              <Row>
                <Divider></Divider>
              </Row>
              <Tabs>
                <TabPane tab="Results" key="1">
                  <SessionRunResult
                    results={results}
                    sessionId={sessionId}
                    enableReruns={true}
                    reruns={rerunningTestCases}
                    downloading={downloading}
                  ></SessionRunResult>
                </TabPane>
                <TabPane tab="Selections" key="2">
                  <SelectionsSummary
                    choices={choices ?? {}}
                  ></SelectionsSummary>
                </TabPane>
                <TabPane tab="Test cases" key="3">
                  <SelectedTestCasesTable
                    choices={choices ?? {}}
                  ></SelectedTestCasesTable>
                </TabPane>
                <TabPane tab="Declaration of Conformity" key="4">
                  <h3>Name: {declarationOfConformity?.name}</h3>
                  <h3>Title: {declarationOfConformity?.title}</h3>
                  <h3>
                    Title function: {declarationOfConformity?.titleFunction}
                  </h3>
                  <h3>Company: {declarationOfConformity?.company}</h3>
                  <h3>Country: {declarationOfConformity?.country}</h3>
                  <h3>Address: {declarationOfConformity?.address}</h3>
                  <h3>
                    Corporate number: {declarationOfConformity?.corporateNumber}
                  </h3>
                  <h3>
                    Application name: {declarationOfConformity?.applicationName}
                  </h3>
                  <h3>Version: {declarationOfConformity?.version}</h3>
                </TabPane>
              </Tabs>
            </>
          )}
        </div>
      </MainLayout>
    </div>
  );
};

export default SessionRunPage;
